// Generated by scripts/fishArt.ts from art/palenose/ (the user's AI-generated art, its terms in art/palenose/provenance.json), each picture's pixels on its grid (initial-phase.png 15.648 by 14.121, terminal-phase.png 15.523 by 15.629 of the picture's a pixel); do not edit. Rebuild: npm run fish-art.
import type { Sprite } from './spriteTypes';

export const PALENOSE_SPRITES: Readonly<Partial<Record<'adult' | 'terminal', Sprite>>> = {
  "adult": {
    "width": 84,
    "height": 48,
    "palette": [
      "#ddcec7",
      "#ac8f86",
      "#553b37",
      "#c9b5aa",
      "#71544e",
      "#8a665f",
      "#9f7569",
      "#fbefe4",
      "#201b1d",
      "#8a5537",
      "#c59870",
      "#e2b17c",
      "#514d4a"
    ],
    "rows": [
      ".................................eeee...............................................",
      "...............................ccbbbbccc............................................",
      "..............................cgbbbbefbbccc.........................................",
      ".............................cfbffeeebbeebbcc.......................................",
      "............................cgbiieeebbeefbeebfccc...................................",
      "...........................cfbiiieebbeeebeefbeebbccc................................",
      "...........................cbfiiebbbeeebeeebeegbefbbccc.............................",
      ".......................cccccccccccccceceecgeefbeebbeebbcc...........................",
      "....................ccccccccceeceecceccccccccbeefbeebbebbcc.........................",
      ".................ccceeeeeceeceeecceeceecceccecccgeefbefbefgccc......................",
      "............ccceeeeeefeefeeffceecceeceeccecceccccccgeebeegbeeecc....................",
      ".........cccceeeeeeeeeeeffeeeecefeeffceeeeeeeecccccccceefbefbbbec................ccc",
      ".......cceeeeeeeeeffeeggeefeefeeefeefceeeceeceeccececcccbeebbbeefcc............ccfbc",
      ".....cceeeeeeeeeeffefffgeefeefeeeffeeffeffeffeecceccececccebeeefbbec.........ccfbbec",
      "....cfffefeeefffffffggfffeeefeffeffeeffeefeffeefeeeeececcccceeebeeecc.......cebbeeec",
      "...cfffffefbcgkkmbfgfffffeefeeffeeffeefeefeeeeefeefeeeccceccccfeefbbc.....ccebfeeec.",
      "..cbddffffbegliageffffgfffeeffeefeffeeffeffeefeefeeeefcceceeccccegfcc....cebbfffbbc.",
      ".cadaaddffbcgiiigcfffggffbeeffeefeffeeffeffeefeeffefefceeceeccecccc....ccegffbbbfec.",
      ".caaaaaadbbegiijgebffggffbefffeeffeeeeeeeeefeeeeffeffeffeceeccecccccccccceeebfeeec..",
      "chhhhaaaabbbcgggebbfffggfbeiiffeffeeefeefeeffeefefeffeffefeeeeeeeeecccccceeebfeeec..",
      "chhhhaaaaabbbeembbbfggfgfbbiiifeefeeffeeffeffeffeeeefeefefeeeeeeecccccccccbbfffbbc..",
      "ahhhhhaaaabbbbbbbbbfgffggbbiiiffecccccffeffefeefeefeefeefeeeeeeefeeeccccceeefbbgfc..",
      "ahhahhhaaabbbbbbbbggggfggbbfiefccbbbbbcfeffeefeefefeefeefeffeeffeffefcceccbbbeeefc..",
      "cccaahhaaaabbbbbbbgggffggbefeccbbbffgbbcfffeefeeffefeefeefffeeffeffeffceccffeeeefc..",
      "cccccchhaaaabbdbbbgggfggbbecccbeffbbbbecffffffeeffeffeffefeefeeffeffeffecceebbbbbc..",
      ".ccccchhaaaabbdbbbgggggbbbcccfffbbbbbfffeffgffbffffffeffefeeffeffeffeffeccffffeefc..",
      "cahhhhhhaaaabbdbbbbggggbbccefebbbfffbgfccbfgbfbffbfffffffffebbffbffbefeeceeffefffc..",
      "caahhhhhaaaddbbdbbbgggbbbeceeffffffgbbgcebbbbfbbfbbfbffbffbffddddbbbbbfeceeeeeefec..",
      "caahhhhaaaaddddddbbggbbbeeceeegbbbbbbbbeebbbbbbbbbbbbdfdddddddbbbbbbfffeceffbbbbbc..",
      ".ccaaaabbbddddddbbbbgbbbbbceeefebffbbbeebdbbddbddbddddddbbbbbbbbddbccccceeeeffbbfcc.",
      "...ccadbbbddddbbbbbbbbbebbceegffbbbbbeeddddddddddddddbbbbbbbbddbbcc...cceebbgefffec.",
      "....cccbbbbbbbbbbbbbbbebbbbcccbbffbbeeedbbddbddbbdbbbbbbbbddddbbbc.....cceeebbbffec.",
      ".....ccbbbbbbbbbbbbbbbebbbbbcecbbbffeddbbbbbbbbbbbbbbddddddbbbbccec......cceffbbbbc.",
      ".......cccbbbbbbbbbbeebbbbbbddeccbbeebbbbbbbbbbbbbbddddbbbbbcccebfec.......cebfffbec",
      "..........ccbbbbeeeeebbbbbbddbbeeeeebbbbbbbbbbbbdddddbbbbbcceebfebec........ccgbfeec",
      "............cccceeeebbbbbbddbbbbbbddddbaadbddbdddddbbbbbccebgffbfec...........ccfeec",
      "................ccceeeeebbddbddddddddddaaadddddddbbbbbcceeefbffebe............ccbbec",
      "...................cccceeeebbbbbbddbbbabbdabbdbbbbbbbceeebfffbffcc..............ccbc",
      "......................cccccbbeeeebbbbbbbbbbbbbbccccccfbffebbefbcc.................cc",
      "...........................cbbefbcccffffffccccc...cebffbfffbbfc.....................",
      "...........................cbbffbbeccccccc.........ccbffbgfffc......................",
      "............................cddfebbfc................cbfebbcc.......................",
      ".............................cddgfbbbc................ccccc.........................",
      "..............................cdgfefbbc.............................................",
      "...............................cdbfffbc.............................................",
      "................................cbdffeec............................................",
      ".................................ccbbbbc............................................",
      "...................................ccccc............................................"
    ]
  },
  "terminal": {
    "width": 77,
    "height": 46,
    "palette": [
      "#cfe7d4",
      "#cc97c1",
      "#68b99f",
      "#8cccb6",
      "#1d7995",
      "#3699b0",
      "#5da471",
      "#6fc8c4",
      "#fbf0db",
      "#378374",
      "#6773af",
      "#8989c3",
      "#a1dbd7",
      "#b3c0ba",
      "#27675e",
      "#56b9bd",
      "#84c097",
      "#b175ab",
      "#154851",
      "#c6b1be",
      "#c98952",
      "#f5dec1",
      "#fbfbfb",
      "#226c75",
      "#231b1c",
      "#497395",
      "#408763",
      "#55a195",
      "#567492"
    ],
    "rows": [
      "............................eeee.............................................",
      "..........................eeppppeee..........................................",
      ".........................ephhhfffpheeee......................................",
      "........................epbbbfffpbffhppeee...................................",
      ".......................epbbsfffbbffpbbffppeee................................",
      "......................xfbbssffbbffpbbffpbffppeee.............................",
      "....................ooofbssffbbffpbbffbbffpbbffpee...........................",
      ".................zeeoooooooooooofbfffbbffpbbffbbffee.........................",
      "..............kkkkkzeCjArrjjrjoroooobbffpbbffbbffpbfee....................eee",
      "............kkkkkkkrjjrjjbbAjrjjrjjroooobbffbbffpbfffpee................eeee.",
      "..........kkkkllkkCzrjgbggbggbbjjbjjrjrjooobbffpbfffpbffe..............efpb..",
      "........kkkkkllllkkjbggbbggbggbggbbggbAbbjoooepbbffhbffppee...........efpbb..",
      ".....kkkkkklllkkbbcggbggbggbbggbggbggbbgbAjbAooeefbbffpbbpfe.........eepbbb..",
      "....kkkkkllklklllbbcgbbggbggbggbbggbggbggbggbgbAoooefpbbffbbe.......eefbbe...",
      "...kkllklkkkkBBcllbcggbggbbggbggbggbbggbgbbggbgbjjbooobffbbpfe......efbbfe...",
      "..kkllllkkBooccccbcccggbggbggbbggbggbggbbgbggbbgbgAboooobbffdbe....efbbff....",
      ".kphkkkkkouywuccbbbcccgbbggbggbggbbggbggbggbgbbggbggbgbooofbb.....efbbfpf....",
      ".khdhpffcouyyucccbbbhdggbggbbggbggbggbbggbgbbgbggbbggbgbgoooo...xefphfpbe....",
      ".iiidhhcccouuocccbbbhassgbggbggbbggbggbggbbgbggbggbggbbggbggjooooefffbbbe....",
      "viiiihhddccoocccccbbhaassbbggbggbggbbggbgbbggbgbbggbggbggbbgbjjrojefbbffe....",
      "viiiiihcccccccccbccchaassgbgeeeeebggbggbbgbggbbgbggbbggbggbggbggboebpffe.....",
      ".ooviiddcccccccbbbcccbdsggeehmmmmegggbgbbggbggbggbggbggbbggbggbggoeefbbe.....",
      ".oosoiidhccccccbbcccbbdoxphhfffhhfeggbggbggbbggggbbggbggbggbbggbgoebbffe.....",
      ".ooosiidddccccbbbccbbboophffbbbbbbeggbbggbggbggbggbggbbggbggbbgggjeebbbe.....",
      "caiiiiidddcccdbbcccbbjofffbbfffphpebggbggbbggbgbbggtggtcqaaatccccjeffbbe.....",
      "caaaiiaccccchddbccbbbjofeffbbbbbbeecbggbgcbggbcgbgqnddaaaadcccccjeepbfffe....",
      ".caaiiccccchhdhbccbbBdxefppbbbbbbeccbbgbcctcctaqdaaaaaadcdcccBjjxeeffbffe....",
      "..daaicccdhhdhhccbbBgdxeffffffpheqncbbcbbcdbddaaaaaaacccdaadjj..eefpfbbbe....",
      "...Baahhhdddhdccbbbjdddxfhffbbbbedncdbqqbcqbddaaadcdccaaadjj.....eepbfpbfe...",
      "....gcccccdddcccbbBdadddeebbffpfednadnadnaaaaaddddddaaadjoee......eebbppfe...",
      ".....jjjcccccccbbgcdadddddebbbfednaaaaaaaaaaaddddaaaaddjobbfe......efbbphe...",
      "........jjcccccBjddaaadaaddeeeeddaaddaddaadddddaaadddjepbpbbe.......epbbpfe..",
      "..........jjjjjcccddddaaadddaddaaddddddddddddaaadddjefbpdbpbe.......eepbbbe..",
      ".............jjjcccdddadddaaaaaaddddddddddaaaadddeebbpdbphhe..........epbbbe.",
      "................jjjccccdddddddddddaaaaaaaaaddddejfpbbpppbfe............epbbe.",
      "...................jjjjccffffddaaaaaaaadddddejebbpppbbppbe..............efbb.",
      "........................mmbffjojdddddddddjjjfphppbbppbbee................eeee",
      "........................jmbbfbbejjjjjjjjj...efhhhpbbpppe...................ee",
      "........................emmbffbbe............eehhhpbppe......................",
      ".........................embbppbbe.............ehhpbbe.......................",
      "..........................mmbbppbfe.............eeeee........................",
      "..........................emmbhpbpe..........................................",
      "...........................jmmbbppe..........................................",
      "............................emmbbbpe.........................................",
      ".............................eemmmhe.........................................",
      "...............................eeeee........................................."
    ]
  }
};
